<div [formGroup]="form">
  <ng-container
    [formGroupName]="i"
    *ngFor="let isr of form?.controls; let i = index">
    <div class="isr-container-fields">
      <app-input-vocabulary-autocomplete
        formControlName="ISRC"
        [vocabularyName]="'V_ISRC'"
        [placeholder]="'Classe di appartenenza (ISRC)'">
      </app-input-vocabulary-autocomplete>
      <app-input-vocabulary-autocomplete
        formControlName="ISRS"
        [vocabularyName]="'V_ISRS'"
        [placeholder]="'Tecnica di scrittura (ISRS)'">
      </app-input-vocabulary-autocomplete>
      <mat-form-field>
        <input
          matInput
          placeholder="Posizione (ISRP)"
          formControlName="ISRP">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Trascrizione (ISRI)"
          formControlName="ISRI">
      </mat-form-field>
      <button
        *roleVisibility="['create', 'update']; classNames: classNames"
        mat-raised-button
        type="button"
        (click)="removeHandler(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </ng-container>
  <button
    *roleVisibility="['create', 'update']; classNames: classNames"
    mat-raised-button
    type="button"
    (click)="addHandler()">
    {{ 'Aggiungi iscrizione' | translate }}
  </button>
</div>
